import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import BoltOutlined from "@mui/icons-material/BoltOutlined";
import PsychologyOutlined from "@mui/icons-material/PsychologyOutlined";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { setChatMode, type ChatMode } from "../store/slices/chatSlice";

// Fast/Expert model selector. Mode is ambient Redux state — chatSlice's
// sendStreamingMessage reads state.chat.chatMode and forwards it as
// ?mode=fast|expert, so this toggle is the only wiring chat v2 needs.
export function ChatModeToggle() {
  const dispatch = useAppDispatch();
  const chatMode = useAppSelector((s) => s.chat.chatMode);

  const handleChange = (
    _: React.MouseEvent<HTMLElement>,
    next: ChatMode | null,
  ) => {
    // exclusive group hands back null when the active button is re-clicked;
    // ignore that so a mode is always selected.
    if (next) dispatch(setChatMode(next));
  };

  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={chatMode}
      onChange={handleChange}
      aria-label="chat mode"
      sx={{ "& .MuiToggleButton-root": { px: 1, py: 0.25, textTransform: "none" } }}
    >
      <ToggleButton
        value="fast"
        aria-label="fast mode"
        title="Fast: lightweight model, ~10s per answer"
      >
        <BoltOutlined sx={{ fontSize: 16, mr: 0.5 }} />
        Fast
      </ToggleButton>
      <ToggleButton
        value="expert"
        aria-label="expert mode"
        title="Expert: thinking model, ~1min per answer"
      >
        <PsychologyOutlined sx={{ fontSize: 16, mr: 0.5 }} />
        Expert
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
